// extracted by mini-css-extract-plugin
export default {"xAxis":"useChartConfig_xAxis__rpLBZ","tooltipDate":"useChartConfig_tooltipDate__UREXj"};